import TextField from '@mui/material/TextField';
import { useIntl } from 'react-intl';
import { getInputDependedLabel, getInputDependedValues } from '../../../modules/getinput';

export const FormTextarea = ({ input, inputValues, requiredFields, handleChange, formSource = '' }) => {
  const intl = useIntl();
  const isAutoreplyForm = formSource === 'autoreply'
  return (
    <TextField
      id={input.id}
      required={requiredFields[input.id]}
      label={intl.formatMessage({
        id: getInputDependedLabel(input, inputValues),
        defaultMessage: getInputDependedLabel(input, inputValues),
      })}
      value={getInputDependedValues(input, inputValues)}
      type="text"
      variant="outlined"
      autoComplete="none"
      multiline
      rows={4}
      helperText={
        isAutoreplyForm
          ? 'Reply text must be less than 600 characters'
          : ''
      }
      inputProps={isAutoreplyForm ? { maxLength: 600 } : {}}
      disabled={!!input.disabled}
      onChange={(event) => handleChange(input.id)(event.target.value)}
    />
  );
};
export default FormTextarea;
